/*
 * @Author: Christion.Young
 * @Date: 2025-09-01 00:00:00
 * @LastEditors: Christion.Young
 * @LastEditTime: 2025-09-01 00:00:00
 * @Description: Home页面配置文件
 *
 * 注意：所有API接口都使用统一的响应格式：
 * {
 *   code: number,    // 状态码，0表示成功
 *   data: Array | Object, // 直接的数据，可能是数组或对象
 *   msg: string | null,   // 消息
 *   ok: boolean      // 是否成功
 * }
 */

// API请求参数配置
export const API_PARAMS = {
  // 轮播图
  BANNERS: {
    current: "1",
    size: "10",
    status: "0", // 启用状态
  },

  // 父级分类
  PARENT_CATEGORIES: {
    current: "1",
    size: "50",
  },

  // 子级分类
  SUB_CATEGORIES: {
    current: "1",
    size: "200",
  },

  // 推荐商家
  RECOMMEND_MERCHANTS: {
    current: "1",
    size: "6",
  },

  // 热门服务
  HOT_SERVICES: {
    current: "1",
    size: "8",
    isRecommended: "1",
    serviceStatus: "1",
  },

  // 平台信息
  PLATFORM_INFO: {
    current: "1",
    size: "1",
  },
};

// 延迟时间配置（毫秒）
export const DELAY_TIMES = {
  BANNERS: 0,
  CATEGORIES: 0,
  MERCHANTS: 0,
  SERVICES: 0,
  MIN_LOADING: 500, // 最小加载时间，避免闪烁
};

// 默认值配置
export const DEFAULT_VALUES = {
  MERCHANT_NAME: "暂未设置商家名称",
  RATING: 4.5,
  AREA: "成都市",
  SERVICE_DESC: "专业服务，品质保证",
  CATEGORY: "综合服务",
  EVALUATE: "5.0",
  BANNER_TITLE: "默认轮播图",
};

// 数据过滤规则
export const FILTER_RULES = {
  // 通用删除标记
  VALID_DEL_FLAGS: ["0", 0, false, null, undefined],

  // 轮播图状态
  VALID_BANNER_STATUS: ["0", 0],

  // 服务状态
  VALID_SERVICE_STATUS: ["1", 1],

  // 推荐状态
  RECOMMENDED_FLAGS: ["1", 1, true],
};

// 图片处理配置
export const IMAGE_CONFIG = {
  DEFAULT_BANNER: require("@/assets/logo.png"),
  DEFAULT_MERCHANT: require("@/assets/logo.png"),
  DEFAULT_SERVICE: require("@/assets/logo.png"),

  // 商家图片尺寸配置
  MERCHANT_IMAGE: {
    MIN_HEIGHT: 180,
    MAX_HEIGHT: 300,
    WIDE_RATIO: 1.5,
    NARROW_RATIO: 0.8,
    WIDE_HEIGHT: 200,
    NARROW_HEIGHT: 280,
    NORMAL_HEIGHT: 240,
  },

  // 服务图片尺寸配置
  SERVICE_IMAGE: {
    MIN_HEIGHT: 140,
    MAX_HEIGHT: 280,
    WIDE_RATIO: 1.5,
    NARROW_RATIO: 0.8,
    WIDE_HEIGHT: 180,
    NARROW_HEIGHT: 260,
    NORMAL_HEIGHT: 220,
  },
};

// 错误消息配置
export const ERROR_MESSAGES = {
  INIT_FAILED: "初始化页面失败",
  CATEGORY_FAILED: "分类数据加载失败，请刷新重试",
  BANNER_FAILED: "轮播图加载失败",
  MERCHANT_FAILED: "推荐商家数据加载失败",
  SERVICE_FAILED: "热门服务数据加载失败",
  PLATFORM_FAILED: "平台信息加载失败",
  CATEGORY_INFO_INCOMPLETE: "分类信息不完整",
  MERCHANT_INFO_INCOMPLETE: "商家信息不完整",
  SERVICE_INFO_INCOMPLETE: "服务信息不完整",
  NAVIGATION_FAILED: "跳转失败，请稍后重试",
};
